module.exports = __webpack_public_path__ + "static/media/savio13.cc88295a.jpg";